import { memo, useCallback, useEffect, useRef, useState } from "react";

import "./Skills.css";

// Copia con la API del portapapeles y, si el navegador la bloquea (p.
// ej. dentro del iframe de Teams), con un textarea temporal.
const copyText = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    const helper = document.createElement("textarea");
    helper.value = text;
    helper.style.position = "fixed";
    helper.style.opacity = "0";
    document.body.appendChild(helper);
    helper.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(helper);
    return copied;
  }
};

// Consola con el SKILL.md que generó /new-skill (channelData.skillMd):
// el archivo tal cual lo validó el bot, listo para copiar y guardar en
// agentic/skills/<nombre>/SKILL.md del backend.
function SkillMdConsole(props: { text: string }) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const name = /^name:\s*([a-z0-9-]+)/m.exec(props.text)?.[1];
  const path = name ? `${name}/SKILL.md` : "SKILL.md";

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    []
  );

  const handleCopy = useCallback(async () => {
    if (!(await copyText(props.text))) return;
    setCopied(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setCopied(false), 2500);
  }, [props.text]);

  return (
    <div className="skillmd-console">
      <div className="skillmd-console__bar">
        <span className="skillmd-console__path" title={path}>
          {path}
        </span>
        <button
          type="button"
          className={
            copied
              ? "skillmd-console__copy skillmd-console__copy--done"
              : "skillmd-console__copy"
          }
          onClick={handleCopy}
        >
          {copied ? "Copied ✓" : "Copy"}
        </button>
      </div>
      <pre className="skillmd-console__body">
        <code>{props.text}</code>
      </pre>
    </div>
  );
}

export default memo(SkillMdConsole);
